// СТАТИКА КАДРА ШАГА 6 (overlay) — строки, одинаковые на всех кадрах борда. B8-3.
//
// ⭐ ЭТО НЕ КОПИ-БАНК. Банк шага 6 — `copy-bank.md` + узел `s6Copy.js` (B8-2): там то, что ветвится по
// раскладу. Здесь — подписи кадра, которые борд печатает одинаково на всех семи кадрах (спека шага 6
// `3b419875cbb88198b9c8cb66fbd53662`, «Что одинаково у всех семи»), и шапки карточек из шаблонов
// `carriersCard` / `mpCard` / `quoteCard`. Источник — байт `Life Map - s6 Overlay v10.html`
// (sha `28c1a6c3…`), `frame()` `:54–74` и шаблоны `:34–51`. Сверка буквы с байтом — машинная,
// `StepSix.test.jsx` («статика кадра = байт v10»).
//
// ⛔ НЕ ЗДЕСЬ: бровь, механизм, карточка scatter, ярлыки поля (узел `s6Copy.js`), italic (`chartCopy.js`),
// имя главного паттерна (`patternName` + `MECH` §V). Футера у шага 6 нет (`footerNav.js`, B8-5).

/** Надзаголовок экрана (v10 `:57`). */
export const S6_EYEBROW = 'your life · the pattern';

/** Заголовок (v10 `:58`): `The <em>line</em><br>through it.` — три куска, разметку ставит экран. */
export const S6_TITLE = { pre: 'The ', em: 'line', post: 'through it.' };

/** Подзаголовок (v10 `:59`). */
export const S6_SUB = 'the shape you lived, and the one move that kept running across it.';

/** Левая бровь чарта (v10 `:61`): `overlay` + разделитель в `<em>` + `browLabel`. */
export const S6_GTAG_HEAD = 'overlay';
export const S6_GTAG_SEP = '·';

/** Правый ярлык чарта (v10 `:62`) — статика. */
export const S6_CHART_RIGHT = 'life · v.0047';

/** Шапка карточки несущей (v10 `:35`, `:37`). Правая подпись — сам ключ `carrierConfig`. */
export const S6_CARRIERS_HEAD = 'the carriers';

/** Карточка главного паттерна (v10 `:45–47`): рельс, бровь, строка доказательств `evidence <em>stages …</em>`. */
export const S6_MP_RAIL = 'main pattern';
export const S6_MP_EYEBROW = 'detected';
export const S6_EV_HEAD = 'evidence';
export const S6_EV_STAGES = 'stages';

/**
 * Разделитель римских в строке доказательств: `NBSP·` + пробел (Н5, ответ CD 25.09, `s849.d2`/`s925.d2`).
 * Неразрывный пробел клеит точку к предыдущей цифре — при переносе вторая строка не начинается с «· X».
 * Борд печатает обычный ` · ` (датасет `I · III · V`) — правило переноса пришло позже борда.
 */
export const S6_EV_JOIN = '\u00A0· ';

/** Карточка цитаты (v10 `:50–51`): шапка, префикс ярлыка поля, подпись. */
export const S6_QUOTE_HEAD = 'your own words';
export const S6_QUOTE_FIELD = 'field · ';
export const S6_QUOTE_AT = '— you, stage ';

/**
 * Close-блок (v10 `:67–71`, одинаков на всех кадрах v10 и Edge Review v1 — спека шага 6, «CTA-блок целиком»).
 * B8-5. Строки — статика кадра, не копи-банк (`copy-bank.md` §3: CTA и подпись — хром). Вопрос — `pre` +
 * курсив `em`; стрелка CTA — свой `<span>` в байте борда (U+2192), не псевдоэлемент.
 */
export const S6_CLOSE = {
  eyebrow: 'the full reading',
  q: { pre: 'this was one line. ', em: 'the document has all seven.' },
  list: ['every layer named, and what it did', 'the patterns that repeat, with evidence', 'your own words, in order'],
  cta: 'Get the full reading',
  arrow: '\u2192',
  sub: 'pdf · 7 pages · free',
};
